import { Pipe, PipeTransform } from '@angular/core';

const DASH = '—';

@Pipe({
  name: 'displayOrDash',
  pure: true,
})
export class DisplayOrDashPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    if (value === null || value === undefined) return DASH;
    if (value === 0 || value === '0') return DASH;
    const s = String(value).trim();
    return s.length > 0 ? s : DASH;
  }
}
